var BuyerOverridesActionTypes;
(function (BuyerOverridesActionTypes) {
  BuyerOverridesActionTypes["SET_LOADING"] = "SET_LOADING";
  BuyerOverridesActionTypes["SET_QUANTITY"] = "SET_QUANTITY";
  BuyerOverridesActionTypes["SET_PRICE"] = "SET_PRICE";
  BuyerOverridesActionTypes["SET_EXPIRED_FUTURE_START_DATE_LINE_ITEMS"] = "SET_EXPIRED_FUTURE_START_DATE_LINE_ITEMS";
  BuyerOverridesActionTypes["SET_PARTIAL_PAYMENT_AMOUNT"] = "SET_PARTIAL_PAYMENT_AMOUNT";
  BuyerOverridesActionTypes["SELECTION_TOGGLED"] = "SELECTION_TOGGLED";
})(BuyerOverridesActionTypes || (BuyerOverridesActionTypes = {}));
export default BuyerOverridesActionTypes;